import { TProductCard, TSeriesListing, TSeriesListingProps, TSeriesListingItemData } from '../types/SeriesListing.types';
import mock from '../../../mocks/ContentHubSeriesListing.mock';

export class SeriesListingModel {
  private readonly data?: TSeriesListing;
  private readonly itemData?: TSeriesListingItemData;
  constructor(props: TSeriesListingProps) {
    this.data = props.fields?.apiData;
    this.itemData = props.fields?.itemData;
  }

  get items(): TProductCard[] {
    return this.data?.items ?? [];
  }

  get total(): number {
    return this.data?.total ?? mock.total;
  }

  get baseUrl(): string {
    return this.itemData?.contextItemUrl || '';
  }
}
